import { render, staticRenderFns } from "./StudentEditData.vue?vue&type=template&id=5d288a39"
import script from "./StudentEditData.vue?vue&type=script&lang=js"
export * from "./StudentEditData.vue?vue&type=script&lang=js"
import style0 from "./StudentEditData.vue?vue&type=style&index=0&id=5d288a39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports